import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, Grid, Header, Segment } from 'semantic-ui-react';
import MediaAssetAccordionStandard from './MediaAssetDescriptive';
import Searchcomp from '../../../app/common/search/searchCategory';
import { useStore } from '../../../app/stores/store';
import '../../../app/common/MediaQuery/responsive-asset-list.css';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

export default observer(function MediaAssetFilters() {
  const {
    // WorkLevelStore,
    activityStore,
    userStore: { user },
    commonStore,
  } = useStore();
  // const { workLevelitemsByDateAll } = WorkLevelStore;
  const { groupedActivities } = activityStore;
  const [dropDownState, setDropDownState] = useState({ activeIndex: 0 });

  const filteredData =
    user?.customerName === 'LVPCMS'
      ? activityStore.groupIdCountsDetails.filter((x) => {
          return x.title !== 'Film Festival';
        })
      : activityStore.groupIdCountsDetails;
  const itemgroupOptions = filteredData?.map((x) => ({
    key: x?.id,
    text: x?.title,
    value: x?.title,
  }));

  const handleItemGroup = (
    _event: any,
    data: any,
    itemGroupUpdate?: { id: string; title: string },
  ) => {
    if (itemGroupUpdate) {
      activityStore.filterItem = itemGroupUpdate.title;
      activityStore.FilterById = itemGroupUpdate.id;
    } else {
      const { value } = data || {};
      const { key } = data?.options?.find((o: any) => o.value === value) || {};
      activityStore.filterItem = value || '';
      activityStore.FilterById = key || '';
    }
    activityStore.currentPage = 1;
    activityStore.FilterCategory = '';
    // activityStore.FilterCategory = activityStore.FilterCategory
    //   ? ""
    //   : activityStore.FilterCategory;
    activityStore.peopleData = false;
    setDropDownState({ activeIndex: -1 });
  };

  return (
    <Segment className="sm-screen-media-asset-filters">
      <Grid columns={2}>
        <div
          style={{
            width: '100%',
            marginBottom: '10px',
            marginTop: '10px',
          }}
          className="MediaAsset-align"
        >
          <Searchcomp filterStyle={false} />
        </div>
        <Grid.Column width="16" className="smallscreenitemgroup">
          <Dropdown
            style={{ width: '100% !important' }}
            placeholder={
              (userLanguage[0].AssetViewItemLevelListPage.AVIDD01 as any)?.[
                `${commonStore.language.key}`
              ]
            } //"Item Group"
            name="Item Group"
            label="Item Group"
            fluid
            clearable
            selection
            options={itemgroupOptions}
            value={activityStore.filterItem}
            onChange={handleItemGroup}
          />
        </Grid.Column>
      </Grid>
      <div className="smallscreenlistfilter">
        {/* <Dropdown
          placeholder={
            (userLanguage[0].AssetViewItemLevelListPage.AVIDD01 as any)?.[
              `${commonStore.language.key}`
            ]
          }
          name="Item Group"
          label="Item Group"
          value={activityStore.filterItem}
          clearable
          selection
          options={itemgroupOptions}
          onChange={handleItemGroup}
        /> */}
        <Header />
        <MediaAssetAccordionStandard
          groupedActivities={groupedActivities}
          dropDownState={dropDownState}
          handleItemGroup={handleItemGroup}
        />
      </div>
    </Segment>
  );
});
